export const enum Scores {
  NormalPrize = 10,
  SpecialPrize = 30,
}
